import React from "react";
import styles from "./Divider.module.css";

const Divider = () => {
  return (
    <div className={styles.root}>
      <div className={styles.rule} />
      <div className={styles.label}>OR</div>
      <div className={styles.rule} />
    </div>
  );
};

export default Divider;
